<template>
  <form class="new-password" @submit.prevent="submit">
    <h1 class="new-password__title">{{ t('newPassword.title') }}</h1>
    <div :class="formItemClasses">
      <input
        class="form-element form--new-password__pw"
        type="password"
        name="password"
        placeholder="Passwort"
        v-model="password"
      />
    </div>
    <div :class="formItemClasses">
      <input
        class="form-element form--new-password__pw"
        type="password"
        name="password2"
        placeholder="Passwort wiederholen"
        v-model="password2"
        @input="debounceValidate()"
      />
    </div>

    <div class="new-password__actions">
      <a class="password-reset-back" @click="router.push({ name: 'home' })"
        >{{ t('global.back') }}</a
      >

      <LinkButton
        icon-right="Arrow"
        form="newPassword"
        :text="t('newPassword.submit')"
      />
    </div>
  </form>
</template>

<script>
  import LinkButton from '@/components/LinkButton.vue'
  import debounce from 'debounce'
  import { useStrings } from '@/composables/useStrings.ts'
  import { useAuthStore } from '@/stores/useAuthStore'
  import { useRouter } from 'vue-router'

  export default {
    name: 'new-password',
    setup(){
      const authStore = useAuthStore()
      const router = useRouter()
      const { t } = useStrings()
      return {
        t,
        authStore,
        router,
      }
    },
    components: {
      LinkButton,
    },
    data() {
      return {
        password: '',
        password2: '',
        passwordsMatch: true,
      }
    },
    computed: {
      formItemClasses: function () {
        let classes = ['form-item']
        if (!this.passwordsMatch) {
          classes.push('form-item--error')
        }
        return classes.join(' ')
      },
    },
    methods: {
      debounceValidate: debounce(function () {
        this.passwordsMatch = this.password === this.password2
      }, 300),
      submit: function () {
        if (this.password.length > 5 && this.passwordsMatch) {
          this.authStore.changeUserPassword({
            password: this.password,
            token: this.router.currentRoute.value.params.token,
          })
        }
      },
    },
  }
</script>

<style lang="scss">
  .new-password {
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
    transition: $transition-base;

    @media (min-height: 260px) {
      margin-top: 6vh;
    }

    @media (min-height: $bp-xs) {
      margin-top: 14vh;
    }

    &__actions {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
</style>
